import { myJsonUpdater } from "./putData.js";

/**
 * Retrieve a token with the given AsprovaId and password,
 *   and authenticate a license with the token
 * @param {{
 *   asprovaId: string,
 *   password: string,
 *   serialNumber: string,
 *   subSerialNumber: string,
 * }} data
 * @returns {Promise<void>}
 */
export async function useSerialWithOnlineLicense(data) {
  const tokenResponse = await myJsonUpdater("/api/license/online/token", "POST", JSON.stringify({
    username: data.asprovaId,
    password: data.password,
    scope: `usage:${data.serialNumber}`,
  }))
  const tokenResponseData = await tokenResponse.json()
  const {accessToken, refreshToken} = tokenResponseData

  await myJsonUpdater("/api/license/online/use", "POST", JSON.stringify({
    asprovaId: data.asprovaId,
    serialNumber: data.serialNumber.toString(),
    subSerialNumber: "0",
    accessToken,
    refreshToken,
  }))
}


export async function logoutOnlineLicense() {
  await myJsonUpdater("/api/license/online/logout", "POST", JSON.stringify({}))
}
